export const EVENT_CLICK = 'click';

export default class TrackingPushService {
  private static instance: TrackingPushService;

  static getInstance (): TrackingPushService {
    if (!TrackingPushService.instance) {
      TrackingPushService.instance = new TrackingPushService();
    }
    return TrackingPushService.instance;
  }

  public pushTrackingAttributes (category: string, action: string, label: string|number, destinationUrl?: string): void {
    // eslint-disable-next-line @typescript-eslint/camelcase
    (window as any).dataLayer_dag = (window as any).dataLayer_dag || [];
    const data: Record<string, any> = {
      event: EVENT_CLICK,
      eventDetail: {
        category,
        action,
        label,
      },
    };
    if (destinationUrl) {
      data.eventDetail.destinationUrl = destinationUrl;
    }
    (window as any).dataLayer_dag.push(data);
  }
}
